module.exports = __webpack_public_path__ + "img/thumbnail_Caracal_m_melanistic.685d6bc7.png";